import { useState, useEffect } from 'react';

type ViewMode = 'entries' | 'history' | 'settings' | 'calendar' | 'support' | 'faq';

export const useViewMode = () => {
    const [viewMode, setViewMode] = useState<ViewMode>('entries');
  
    useEffect(() => {
      const savedViewMode = localStorage.getItem('viewMode') as ViewMode;
      if (savedViewMode) {
        setViewMode(savedViewMode);
      }
    }, []);
    const toggleViewMode = (mode: ViewMode) => {
      setViewMode(mode);
      localStorage.setItem('viewMode', mode);
    };
    return { viewMode, toggleViewMode };
  };